module.exports = __webpack_public_path__ + "img/banner-1.dbcc6e2f.jpg";